export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const RESTORE_SESSION = 'RESTORE_SESSION';

export const SET_AUTH_STAFF = 'SET_AUTH_STAFF';

export const SEND_OTP_REQUEST = 'SEND_OTP_REQUEST';
export const SEND_OTP_SUCCESS = 'SEND_OTP_SUCCESS';
export const SEND_OTP_FAILURE = 'SEND_OTP_FAILURE';

export const LOGIN_WITH_OTP_REQUEST = 'LOGIN_WITH_OTP_REQUEST';
export const LOGIN_WITH_OTP_SUCCESS = 'LOGIN_WITH_OTP_SUCCESS';
export const LOGIN_WITH_OTP_FAILURE = 'LOGIN_WITH_OTP_FAILURE';

export const GET_CLINIC_REQUEST = 'GET_CLINIC_REQUEST';
export const GET_CLINIC_SUCCESS = 'GET_CLINIC_SUCCESS';
export const GET_CLINIC_FAILURE = 'GET_CLINIC_FAILURE';

export const SET_SELECTED_CLINIC = 'SET_SELECTED_CLINIC';
